import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useModal } from '../../../Providers/ModalContext';

import ArrowRight from '../../../../Images/icons/arrow-right.png';
import LogoStudio from '../../../../Images/logos/logo-studio.png';
import LogoFilms from '../../../../Images/logos/logo_films_nav.png';

import {
  NAV_FILMS,
  NAV_STUDIO,
  TIT_PORTFOLIO,
  SUB_PORTAFOLIO,
  TIT_CAMPAINGS,
  CAMPAINGS_ITEMS,
  TIT_SPOTS,
  SPOT_ITEMS,
  TIT_CORP,
  CORP_ITEMS,
  TIT_POST,
  POST_ITEMS,
  TIT_VIDEOCLIPS,
  VIDEOCLIPS_ITEMS,
  TIT_SOCIAL,
  SOCIAL_ITEMS,
  TIT_PHOTO,
  SUB_PHOTO,
  TIT_FASHION,
  FASHION_ITEMS,
  TIT_RETRATO,
  RETRATO_ITEMS,
  TIT_SPORTS,
  SPORTS_ITEMS,
  TIT_DRINKS,
  DRINKS_ITEMS,
  TIT_CULTURAL,
  CULTURAL_ITEMS,
  TIT_CAMPANAS,
  CAMPANAS_ITEMS,
} from '../../../../utils/ES/Menu/index';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const LevelWrapper = styled(motion.div)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (max-width: ${breakpoints.mobile}) {
    align-items: flex-start;
  }

  .films,
  .studio {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 5rem;
    flex-direction: column;
    max-width: 410px;
    width: 100%;

    @media (max-width: ${breakpoints.mobile}) {
      max-width: 245px;
    }
  }

  .films & {
    @media (max-width: ${breakpoints.mobile}) {
      align-items: flex-end;
    }
  }

  .studio {
    max-width: 445px;
    align-items: flex-start;
    margin-right: 0;
    gap: 2.5rem;

    @media (max-width: ${breakpoints.mobile}) {
      max-width: 245px;
    }
  }

  &.level-campanas,
  &.level-spots,
  &.level-corporativo,
  &.level-postProduction,
  &.level-videoclips,
  &.level-social,
  &.level-fashion,
  &.level-retrato,
  &.level-sports,
  &.level-drinks,
  &.level-cultural,
  &.level-photoCampanas {
    justify-content: flex-start;
    padding-top: 5%;

    @media (max-width: ${breakpoints.mobile}) {
      padding-top: 25%;
    }
  }
`;

const LogoMenu = styled.img`
  max-width: 424px;
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;

  .films & {
    right: 0;

    @media (max-width: ${breakpoints.mobile}) {
      right: 20%;
    }
  }

  .studio & {
    left: 0;

    @media (max-width: ${breakpoints.mobile}) {
      left: 20%;
    }
  }

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 183px;
    top: 10%;
    margin: 0 auto;
  }
`;

const MenuItem = styled.div`
  font-size: 3rem;
  line-height: 1;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s;
  width: fit-content;

  text-align: left;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 1.5rem;
  }

  .films & {
    text-align: right;

    &:hover {
      text-shadow: 0px 0px 14px rgba(147, 206, 255, 1);
      transform-origin: right center;
    }
  }

  &:hover {
    text-shadow: 0px 0px 14px rgba(250, 115, 19, 1);
    transform: scale(1.1);
    transform-origin: left center;
  }
`;

const BackButton = styled.div`
  position: absolute;
  width: 64px;
  height: auto;
  cursor: pointer;
  z-index: 1;

  @media (max-width: ${breakpoints.mobile}) {
    width: 41px;
  }

  img {
    width: 100%;
    height: auto;
    cursor: pointer;

    &:hover {
      filter: drop-shadow(0px 0px 14px rgba(255, 255, 255, 1))
        drop-shadow(0px 0px 3px rgba(255, 255, 255, 1));
    }
  }

  .films & {
    right: 0;
    top: 30%;

    @media (max-width: ${breakpoints.mobile}) {
      right: 0;
      top: 10%;
    }
  }

  .studio & {
    left: 0;
    top: 30%;

    @media (max-width: ${breakpoints.mobile}) {
      left: 0;
      top: 10%;
    }

    img {
      transform: rotate(180deg);
    }
  }
`;

const SubMenuWrapper = styled.div`
  .level-photo & {
    max-width: 445px;
    width: 100%;
  }

  .studio {
    max-width: 565px;
  }
`;

const Title = styled.div`
  font-size: 3.375rem;
  line-height: 1;
  text-transform: uppercase;
  text-shadow: 0px 0px 14px rgba(250, 115, 19, 1);

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 2rem;
  }
`;

const SubMenuContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3.375rem;
  flex-direction: column;
`;

const Logo = styled.img`
  display: block;
  max-width: 444px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 183px;
  }
`;

const SubMenuContent = styled.div`
  max-width: 1194px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 3.375rem;
  flex-direction: column;
  padding-bottom: 10%;

  @media (max-width: ${breakpoints.mobile}) {
    gap: 1.375rem;
  }

  &.content-corporativo,
  &.content-videoclips,
  &.content-sports,
  &.content-photoCampanas {
    max-width: 1413px;
    margin-top: 5%;
  }

  &.content-social,
  &.content-fashion,
  &.content-retrato,
  &.content-cultural {
    max-width: 1265px;
  }

  .level-postProduction & {
    padding-bottom: 0;
  }

  .level-videoclips & {
    padding-bottom: 0;
  }

  .level-social & {
    padding-bottom: 0;
  }
`;

const SubMenuTitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 1.313rem;

  &.content-corporativo,
  &.content-videoclips,
  &.content-social,
  &.content-fashion,
  &.content-retrato,
  &.content-sports,
  &.content-cultural,
  &.content-photoCampanas {
    align-items: flex-start;
    width: 100%;

    @media (max-width: ${breakpoints.mobile}) {
      justify-content: center;
      width: 100%;
      flex-wrap: wrap;
      align-items: center;
    }
  }

  @media (max-width: ${breakpoints.mobile}) {
    justify-content: center;
    width: 100%;
  }
`;

const SubMenuTitle = styled.div`
  font-size: 4rem;
  line-height: 1;
  text-transform: uppercase;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 2rem;
  }

  &.content-corporativo,
  &.content-videoclips,
  &.content-social,
  &.content-fashion,
  &.content-retrato,
  &.content-sports,
  &.content-cultural,
  &.content-photoCampanas {
    font-size: 3.375rem;

    @media (max-width: ${breakpoints.mobile}) {
      font-size: 2rem;
    }
  }
`;

const SubMenuBack = styled.div`
  max-width: 64px;
  width: 100%;
  height: 64px;
  cursor: pointer;
  z-index: 1;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 41px;
    height: 41px;
  }

  img {
    width: 100%;
    height: auto;
    cursor: pointer;
    transform: rotate(180deg);

    &:hover {
      filter: drop-shadow(0px 0px 14px rgba(255, 255, 255, 1))
        drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    }
  }
`;

const SubMenuGrid = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  gap: 1.5rem;

  @media (max-width: ${breakpoints.mobile}) {
    align-items: center;
    padding: 0 3%;
  }
`;

const GridItem = styled.div`
  max-width: 263px;
  height: 255px;
  width: 25%;
  background-image: url(${({ $bgImage = '' }) => $bgImage});
  background-position: top left;
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
  transition: all 0.2s ease;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 170px;
    height: 168px;
    width: 43%;
  }

  &:hover {
    max-width: 283px;
    height: 275px;
    background-image: url(${({ $bgImageHov = '' }) => $bgImageHov});

    @media (max-width: ${breakpoints.mobile}) {
      max-width: 187px;
      height: 181px;
    }
  }

  &.content-corporativo,
  &.content-videoclips,
  &.content-social,
  &.content-fashion,
  &.content-retrato,
  &.content-sports,
  &.content-cultural,
  &.content-photoCampanas {
    width: 100%;
  }
`;

const variants = {
  enter: (dir) => ({
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (dir) => ({
    opacity: 0,
  }),
};

const MenuLevel = ({
  level,
  type,
  direction,
  onClose,
  goTo,
  goBack,
  isRoot,
}) => {
  const { openModal } = useModal();

  const handleClick = (e) => {
    const target = e.currentTarget.dataset.target;
    openModal(target);
  };

  const handleMenuClick = (item) => (e) => {
    if (item.subMenu) {
      goTo(item.subMenu);
    } else {
      handleClick(e);
    }
  };

  const isFilms = type === 'films';

  const renderContent = () => {
    switch (level) {
      case 'main':
        return (
          <>
            {isFilms ? (
              <>
                <div className="films">
                  <BackButton onClick={isRoot ? onClose : goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </BackButton>
                  <LogoMenu src={LogoFilms} alt="Kuter Studio" />
                  {NAV_FILMS.map((item, index) => (
                    <MenuItem
                      key={item.id || index}
                      data-target={item.modal}
                      onClick={handleMenuClick(item)}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="studio">
                  <BackButton onClick={isRoot ? onClose : goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </BackButton>
                  <LogoMenu src={LogoStudio} alt="Kuter Studio" />
                  {NAV_STUDIO.map((item, index) => (
                    <MenuItem
                      key={item.id || index}
                      data-target={item.modal}
                      onClick={handleMenuClick(item)}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </div>
              </>
            )}
          </>
        );

      case 'portfolio':
        return (
          <>
            <SubMenuWrapper>
              <div className="studio">
                <BackButton onClick={goBack}>
                  <img src={ArrowRight} alt="Arrow" />
                </BackButton>
                <LogoMenu src={LogoStudio} alt="Kuter Studio" />

                {TIT_PORTFOLIO.map((item, index) => (
                  <Title key={item.id || index}>{item.label}</Title>
                ))}

                {SUB_PORTAFOLIO.map((item, index) => (
                  <MenuItem
                    key={item.id || index}
                    data-target={item.modal}
                    onClick={handleMenuClick(item)}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </div>
            </SubMenuWrapper>
          </>
        );

      case 'campanas':
        return (
          <>
            <SubMenuContainer>
              <Logo src={LogoStudio} alt="Kuter Studio" />
              <SubMenuContent>
                <SubMenuTitleContainer>
                  <SubMenuBack onClick={goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </SubMenuBack>
                  {TIT_CAMPAINGS.map((item, index) => (
                    <SubMenuTitle key={item.id || index}>
                      {item.label}
                    </SubMenuTitle>
                  ))}
                </SubMenuTitleContainer>
                <SubMenuGrid>
                  {CAMPAINGS_ITEMS.map((item, index) => (
                    <GridItem
                      key={item.id || index}
                      data-target={item.modal}
                      onClick={handleMenuClick(item)}
                      $bgImage={item.bgImage}
                      $bgImageHov={item.bgImageHov}
                    />
                  ))}
                </SubMenuGrid>
              </SubMenuContent>
            </SubMenuContainer>
          </>
        );

      case 'spots':
        return (
          <>
            <SubMenuContainer>
              <Logo src={LogoStudio} alt="Kuter Studio" />
              <SubMenuContent>
                <SubMenuTitleContainer>
                  <SubMenuBack onClick={goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </SubMenuBack>
                  {TIT_SPOTS.map((item, index) => (
                    <SubMenuTitle key={item.id || index}>
                      {item.label}
                    </SubMenuTitle>
                  ))}
                </SubMenuTitleContainer>
                <SubMenuGrid>
                  {SPOT_ITEMS.map((item, index) => (
                    <GridItem
                      key={item.id || index}
                      data-target={item.modal}
                      onClick={handleMenuClick(item)}
                      $bgImage={item.bgImage}
                      $bgImageHov={item.bgImageHov}
                    />
                  ))}
                </SubMenuGrid>
              </SubMenuContent>
            </SubMenuContainer>
          </>
        );

      case 'corporativo':
        return (
          <>
            <SubMenuContainer>
              <Logo src={LogoStudio} alt="Kuter Studio" />
              <SubMenuContent className={`content-${level}`}>
                <SubMenuTitleContainer className={`content-${level}`}>
                  <SubMenuBack onClick={goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </SubMenuBack>
                  {TIT_CORP.map((item, index) => (
                    <SubMenuTitle
                      key={item.id || index}
                      className={`content-${level}`}
                    >
                      {item.label}
                    </SubMenuTitle>
                  ))}
                  <SubMenuGrid className={`content-${level}`}>
                    {CORP_ITEMS.map((item, index) => (
                      <GridItem
                        key={item.id || index}
                        data-target={item.modal}
                        onClick={handleMenuClick(item)}
                        $bgImage={item.bgImage}
                        $bgImageHov={item.bgImageHov}
                        className={`content-${level}`}
                      />
                    ))}
                  </SubMenuGrid>
                </SubMenuTitleContainer>
              </SubMenuContent>
            </SubMenuContainer>
          </>
        );

      case 'postProduction':
        return (
          <>
            <SubMenuContainer>
              <Logo src={LogoStudio} alt="Kuter Studio" />
              <SubMenuContent>
                <SubMenuTitleContainer>
                  <SubMenuBack onClick={goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </SubMenuBack>
                  {TIT_POST.map((item, index) => (
                    <SubMenuTitle key={item.id || index}>
                      {item.label}
                    </SubMenuTitle>
                  ))}
                </SubMenuTitleContainer>
                <SubMenuGrid>
                  {POST_ITEMS.map((item, index) => (
                    <GridItem
                      key={item.id || index}
                      data-target={item.modal}
                      onClick={handleMenuClick(item)}
                      $bgImage={item.bgImage}
                      $bgImageHov={item.bgImageHov}
                    />
                  ))}
                </SubMenuGrid>
              </SubMenuContent>
            </SubMenuContainer>
          </>
        );

      case 'videoclips':
        return (
          <>
            <SubMenuContainer>
              <Logo src={LogoStudio} alt="Kuter Studio" />
              <SubMenuContent className={`content-${level}`}>
                <SubMenuTitleContainer className={`content-${level}`}>
                  <SubMenuBack onClick={goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </SubMenuBack>
                  {TIT_VIDEOCLIPS.map((item, index) => (
                    <SubMenuTitle
                      key={item.id || index}
                      className={`content-${level}`}
                    >
                      {item.label}
                    </SubMenuTitle>
                  ))}
                  <SubMenuGrid className={`content-${level}`}>
                    {VIDEOCLIPS_ITEMS.map((item, index) => (
                      <GridItem
                        key={item.id || index}
                        data-target={item.modal}
                        onClick={handleMenuClick(item)}
                        $bgImage={item.bgImage}
                        $bgImageHov={item.bgImageHov}
                        className={`content-${level}`}
                      />
                    ))}
                  </SubMenuGrid>
                </SubMenuTitleContainer>
              </SubMenuContent>
            </SubMenuContainer>
          </>
        );

      case 'social':
        return (
          <>
            <SubMenuContainer>
              <Logo src={LogoStudio} alt="Kuter Studio" />
              <SubMenuContent className={`content-${level}`}>
                <SubMenuTitleContainer className={`content-${level}`}>
                  <SubMenuBack onClick={goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </SubMenuBack>
                  {TIT_SOCIAL.map((item, index) => (
                    <SubMenuTitle
                      key={item.id || index}
                      className={`content-${level}`}
                    >
                      {item.label}
                    </SubMenuTitle>
                  ))}
                  <SubMenuGrid className={`content-${level}`}>
                    {SOCIAL_ITEMS.map((item, index) => (
                      <GridItem
                        key={item.id || index}
                        data-target={item.modal}
                        onClick={handleMenuClick(item)}
                        $bgImage={item.bgImage}
                        $bgImageHov={item.bgImageHov}
                        className={`content-${level}`}
                      />
                    ))}
                  </SubMenuGrid>
                </SubMenuTitleContainer>
              </SubMenuContent>
            </SubMenuContainer>
          </>
        );

      case 'photo':
        return (
          <>
            <SubMenuWrapper>
              <div className="studio">
                <BackButton onClick={goBack}>
                  <img src={ArrowRight} alt="Arrow" />
                </BackButton>
                <LogoMenu src={LogoStudio} alt="Kuter Studio" />

                {TIT_PHOTO.map((item, index) => (
                  <Title key={item.id || index}>{item.label}</Title>
                ))}

                {SUB_PHOTO.map((item, index) => (
                  <MenuItem
                    key={item.id || index}
                    data-target={item.modal}
                    onClick={handleMenuClick(item)}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </div>
            </SubMenuWrapper>
          </>
        );

      case 'fashion':
        return (
          <>
            <SubMenuContainer>
              <Logo src={LogoStudio} alt="Kuter Studio" />
              <SubMenuContent className={`content-${level}`}>
                <SubMenuTitleContainer className={`content-${level}`}>
                  <SubMenuBack onClick={goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </SubMenuBack>
                  {TIT_FASHION.map((item, index) => (
                    <SubMenuTitle
                      key={item.id || index}
                      className={`content-${level}`}
                    >
                      {item.label}
                    </SubMenuTitle>
                  ))}
                  <SubMenuGrid className={`content-${level}`}>
                    {FASHION_ITEMS.map((item, index) => (
                      <GridItem
                        key={item.id || index}
                        data-target={item.modal}
                        onClick={handleMenuClick(item)}
                        $bgImage={item.bgImage}
                        $bgImageHov={item.bgImageHov}
                        className={`content-${level}`}
                      />
                    ))}
                  </SubMenuGrid>
                </SubMenuTitleContainer>
              </SubMenuContent>
            </SubMenuContainer>
          </>
        );

      case 'retrato':
        return (
          <>
            <SubMenuContainer>
              <Logo src={LogoStudio} alt="Kuter Studio" />
              <SubMenuContent className={`content-${level}`}>
                <SubMenuTitleContainer className={`content-${level}`}>
                  <SubMenuBack onClick={goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </SubMenuBack>
                  {TIT_RETRATO.map((item, index) => (
                    <SubMenuTitle
                      key={item.id || index}
                      className={`content-${level}`}
                    >
                      {item.label}
                    </SubMenuTitle>
                  ))}
                  <SubMenuGrid className={`content-${level}`}>
                    {RETRATO_ITEMS.map((item, index) => (
                      <GridItem
                        key={item.id || index}
                        data-target={item.modal}
                        onClick={handleMenuClick(item)}
                        $bgImage={item.bgImage}
                        $bgImageHov={item.bgImageHov}
                        className={`content-${level}`}
                      />
                    ))}
                  </SubMenuGrid>
                </SubMenuTitleContainer>
              </SubMenuContent>
            </SubMenuContainer>
          </>
        );

      case 'sports':
        return (
          <>
            <SubMenuContainer>
              <Logo src={LogoStudio} alt="Kuter Studio" />
              <SubMenuContent className={`content-${level}`}>
                <SubMenuTitleContainer className={`content-${level}`}>
                  <SubMenuBack onClick={goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </SubMenuBack>
                  {TIT_SPORTS.map((item, index) => (
                    <SubMenuTitle
                      key={item.id || index}
                      className={`content-${level}`}
                    >
                      {item.label}
                    </SubMenuTitle>
                  ))}
                  <SubMenuGrid className={`content-${level}`}>
                    {SPORTS_ITEMS.map((item, index) => (
                      <GridItem
                        key={item.id || index}
                        data-target={item.modal}
                        onClick={handleMenuClick(item)}
                        $bgImage={item.bgImage}
                        $bgImageHov={item.bgImageHov}
                        className={`content-${level}`}
                      />
                    ))}
                  </SubMenuGrid>
                </SubMenuTitleContainer>
              </SubMenuContent>
            </SubMenuContainer>
          </>
        );

      case 'drinks':
        return (
          <>
            <SubMenuContainer>
              <Logo src={LogoStudio} alt="Kuter Studio" />
              <SubMenuContent>
                <SubMenuTitleContainer>
                  <SubMenuBack onClick={goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </SubMenuBack>
                  {TIT_DRINKS.map((item, index) => (
                    <SubMenuTitle key={item.id || index}>
                      {item.label}
                    </SubMenuTitle>
                  ))}
                </SubMenuTitleContainer>
                <SubMenuGrid>
                  {DRINKS_ITEMS.map((item, index) => (
                    <GridItem
                      key={item.id || index}
                      data-target={item.modal}
                      onClick={handleMenuClick(item)}
                      $bgImage={item.bgImage}
                      $bgImageHov={item.bgImageHov}
                    />
                  ))}
                </SubMenuGrid>
              </SubMenuContent>
            </SubMenuContainer>
          </>
        );

      case 'cultural':
        return (
          <>
            <SubMenuContainer>
              <Logo src={LogoStudio} alt="Kuter Studio" />
              <SubMenuContent className={`content-${level}`}>
                <SubMenuTitleContainer className={`content-${level}`}>
                  <SubMenuBack onClick={goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </SubMenuBack>
                  {TIT_CULTURAL.map((item, index) => (
                    <SubMenuTitle
                      key={item.id || index}
                      className={`content-${level}`}
                    >
                      {item.label}
                    </SubMenuTitle>
                  ))}
                  <SubMenuGrid className={`content-${level}`}>
                    {CULTURAL_ITEMS.map((item, index) => (
                      <GridItem
                        key={item.id || index}
                        data-target={item.modal}
                        onClick={handleMenuClick(item)}
                        $bgImage={item.bgImage}
                        $bgImageHov={item.bgImageHov}
                        className={`content-${level}`}
                      />
                    ))}
                  </SubMenuGrid>
                </SubMenuTitleContainer>
              </SubMenuContent>
            </SubMenuContainer>
          </>
        );

      case 'photoCampanas':
        return (
          <>
            <SubMenuContainer>
              <Logo src={LogoStudio} alt="Kuter Studio" />
              <SubMenuContent className={`content-${level}`}>
                <SubMenuTitleContainer className={`content-${level}`}>
                  <SubMenuBack onClick={goBack}>
                    <img src={ArrowRight} alt="Arrow" />
                  </SubMenuBack>
                  {TIT_CAMPANAS.map((item, index) => (
                    <SubMenuTitle
                      key={item.id || index}
                      className={`content-${level}`}
                    >
                      {item.label}
                    </SubMenuTitle>
                  ))}
                  <SubMenuGrid className={`content-${level}`}>
                    {CAMPANAS_ITEMS.map((item, index) => (
                      <GridItem
                        key={item.id || index}
                        data-target={item.modal}
                        onClick={handleMenuClick(item)}
                        $bgImage={item.bgImage}
                        $bgImageHov={item.bgImageHov}
                        className={`content-${level}`}
                      />
                    ))}
                  </SubMenuGrid>
                </SubMenuTitleContainer>
              </SubMenuContent>
            </SubMenuContainer>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <LevelWrapper
      custom={direction}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{ duration: 0.1, ease: 'easeInOut' }}
      className={`${type} level-${level}`}
    >
      {renderContent()}
    </LevelWrapper>
  );
};

export default MenuLevel;
